<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              골프클럽 수정
            </div>
          </section>
          <!-- 휴장일 설정 활성화(Class) : offDayActive -->
          <!-- 휴장홀 노출시(Class) : closedHoleActive -->
          <section class="section02" :class="{offDayActive: isOffDate, closedHoleActive: true}">
            <div class="objectBox">
              <div class="objectRow first">
                <div class="objectTitle">
                  <div class="object02 objectRequired"></div>
                  <div class="object03">
                    상태
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object04">
                    <ul>
                      <li class="active">
                        <label>
                          <input type="radio" v-model="clubInfo.active_status" value="active"/>
                          <i></i>
                          <span>활성화</span>
                        </label>
                      </li>
                      <li class="inactive">
                        <label>
                          <input type="radio" v-model="clubInfo.active_status"  value="inactive"/>
                          <i></i>
                          <span>비활성화</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <!--
                  <div class="object05"></div>
                  -->
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object07">
                    골프클럽명
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object08">
                    <input type="text" v-model="clubInfo.club_name" />
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object10">
                    주소
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object1101">
                    <input type="text" v-model="clubInfo.club_address"/>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object13">
                    연락처
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object14">
                    <input type="text" v-model="clubInfo.club_telno"/>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object16">
                    대표자명
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object17">
                    <input type="text" v-model="clubInfo.club_represent_name"/>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object19 objectRequired"></div>
                  <div class="object20">
                    운영 상태
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object21">
                    <div class="formSelect" ref="select01">
                      <div class="formSelectList" @click="openSelect01">
                        <input type="text" v-model="manageStatusName" placeholder="운영상태" readonly />
                      </div>
                      <div class="formSelectPopup select01">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="운영 상태를 선택하세요." />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="manageStatusInfo in manageStatusList" :key="manageStatusInfo.name">
                                      <label>
                                        <input type="radio" v-model="selectManageStatus" :value="manageStatusInfo.code" v-on:change="confirmManageStatus"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{manageStatusInfo.name}}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object23 objectRequired"></div>
                  <div class="object24">
                    APL 지원 상태
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object25">
                    <div class="formSelect" ref="select02">
                      <div class="formSelectList" @click="openSelect02">
                        <input type="text" v-model="aplStatusName" placeholder="APL상태" readonly />
                      </div>
                      <div class="formSelectPopup select02">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder="APL 지원 상태를 선택하세요." />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="aplStatusInfo in aplStatusList" :key="aplStatusInfo.name">
                                      <label>
                                        <input type="radio" v-model="selectAplStatus" :value="aplStatusInfo.code" v-on:change="confirmAplStatus"/>
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{aplStatusInfo.name}}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object27 objectRequired"></div>
                  <div class="object28">
                    지역
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object29">
                    <div class="formSelect" ref="select03">
                      <div class="formSelectList" @click="openSelect03">
                        <input type="text" v-model=clubRegionName placeholder='지역을 선택하세요.' readonly />
                      </div>
                      <div class="formSelectPopup select03">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder='지역을 선택하세요.' />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="clubRegion_Name in clubRegion" :key="clubRegion_Name.name">
                                      <label>
                                        <input type="radio" v-model="selectClubRegion" :value="clubRegion_Name.code" v-on:change="setRegion" />
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{clubRegion_Name.name}}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object31">
                    핀 사이즈(mm)
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object32">
                    <div class="formSelect" ref="select04">
                      <div class="formSelectList" @click="openSelect04">
                        <input type="text" v-model="pinSize" placeholder='사이즈를 선택하세요.' readonly />
                      </div>
                      <div class="formSelectPopup select04">
                        <div class="formSelectPopup-container">
                          <div class="outer">
                            <div class="inner">
                              <div class="formSelectPopup-box">
                                <div class="formSelectPopup-zone">
                                  <div class="formSelectPopup-header">
                                    <input type="text" placeholder='사이즈를 선택하세요.' />
                                  </div>
                                  <ul class="formSelectPopup-body">
                                    <li v-for="pin_Size in pinSizeArr" :key="pin_Size.size">
                                      <label>
                                        <input type="radio" v-model="selectPinSize" :value="pin_Size.code" v-on:change="setPinSize" />
                                        <input type="checkbox" />
                                        <i></i>
                                        <span>{{pin_Size.size}}</span>
                                      </label>
                                    </li>
                                  </ul>
                                  <div class="formSelectPopup-footer">
                                    <button class="formSelectPopup-cancel">
                                      취소
                                    </button>
                                    <!-- 비활성(Attribute) : disabled -->
                                    <button class="formSelectPopup-confirm">
                                      확인
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object34">
                    휴장일 설정
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object35">
                    <div class="component-switch">
                      <div class="co-body">
                        <label>
                          <input type="checkbox" v-model="isOffDate" />
                          <i></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="offDaySetting">
                <div class="objectRow">
                  <div class="objectTitle">
                    <div class="object37">
                      기간
                    </div>
                  </div>
                  <div class="objectContent">
                    <div class="object38">
                      <div class="formCalendar">
                        <div class="formCalendarList">
                          <date-picker
                            v-model="offDateRange"
                            type="date" range
                            :format="'YYYY-MM-DD'"
                            :clearable="false"
                            :editable="false"
                            @change="updateValues"
                          >
                          </date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="objectRow">
                  <div class="objectTitle">
                    <div class="object40">
                      주차/요일
                    </div>
                  </div>
                  <div class="objectContent">
                    <div class="object41">

                      <div class="checkbox" >
                        <ul>
                          <li v-for="check_days in checkDaysArr" :key="check_days.name">
                            <label>
                              <input type="checkbox" v-model="selectDay" :value="check_days.num" v-on:change="setDayWeek" />
                              <i></i>
                              <span>{{check_days.name}}</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div class="formSelect" ref="select05">
                        <div class="formSelectList" @click="openSelect05">
                          <input type="text" v-model="dayWeek" placeholder="요일" readonly />
                        </div>
                        <div class="formSelectPopup select05">
                          <div class="formSelectPopup-container">
                            <div class="outer">
                              <div class="inner">
                                <div class="formSelectPopup-box">
                                  <div class="formSelectPopup-zone">
                                    <div class="formSelectPopup-header">
                                      <input type="text" placeholder="요일" />
                                    </div>
                                    <ul class="formSelectPopup-body">
                                      <li v-for="day_Week in dayWeekArr" :key="day_Week.day">
                                        <label>
                                          <input type="radio" v-model="selectDayWeek" :value="day_Week.cnt" v-on:change="setDayWeek" />
                                          <input type="checkbox" />
                                          <i></i>
                                          <span>{{day_Week.day}}</span>
                                        </label>
                                      </li>
                                    </ul>
                                    <div class="formSelectPopup-footer">
                                      <button class="formSelectPopup-cancel">
                                        취소
                                      </button>
                                      <!-- 비활성(Attribute) : disabled -->
                                      <button class="formSelectPopup-confirm">
                                        확인
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="objectRow closedHole">
                  <div class="objectTitle">
                    <div class="object43">
                      휴장홀 설정
                    </div>
                  </div>
                  <div class="objectContent">
                    <div class="object44">
                      <div class="button" @click="selectHolidayHoles">
                        선택하기
                      </div>
                      <ul class="list">
                        <li v-for="(holes, course) in holidayHoles" :key="course">
                          {{course}} - {{ holes.join('홀, ') }}홀
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object46">
                    비고
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object47">
                    <input type="text"  v-model="clubInfo.pin_change" />
                  </div>
                </div>
              </div>
              <div class="objectRow">
                <div class="objectTitle">
                  <div class="object49">
                    특이사항
                  </div>
                </div>
                <div class="objectContent">
                  <div class="object50">
                    <input type="text"  v-model="clubInfo.uniqueness" />
                  </div>
                </div>
              </div>
              <div class="objectRow last">
                <div class="objectTitle">
                  <div class="object52">
                    골프클럽 로고
                  </div>
                  <div class="object53" :class="tooltipActive ? 'tooltipActive' : ''" ref="tooltip" @click="openTooltip">
                    <div class="tooltip">
                      76x26 사이즈로 등록하세요. 100KB 이하의 이미지 파일(jpg,gif,png)만 등록 가능합니다.
                    </div>
                  </div>
                </div>
                <div class="objectContent">
                  <!-- 툴팁 활성(Class) : tooltipActive -->
                  <!-- 첨부파일 있을때(Class) : imageActive -->
                  <div class="object54" :class="clubInfo.club_logo !== '' && clubInfo.club_logo !== null  ? 'imageActive' : ''">
                    <div class="attachment">
                      <div class="bg">
                        이미지를 첨부해주세요.
                      </div>
                      <div class="image">
                        <div class="item" :style="{'background-image': 'url(' + clubInfo.club_logo + ')'}"></div>
                      </div>
                      <input @change="handleImage" type="file" accept="image/*" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <div class="object01">
              <button class="cancel" @click="editCancel">
                취소
              </button>
            </div>
            <div class="object02">
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" @click="saveData">
                수정
              </button>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    {{alertMessage}}
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeAlert">
                      취소
                    </button>
                    <button class="confirm" @click="confirmAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="운영 상태를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="manageStatusInfo in manageStatusList" :key="manageStatusInfo.name">
                      <label>
                        <input type="radio" v-model="selectManageStatus" :value="manageStatusInfo.code" v-on:change="confirmManageStatus"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{manageStatusInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="APL 지원 상태를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="aplStatusInfo in aplStatusList" :key="aplStatusInfo.name">
                      <label>
                        <input type="radio" v-model="selectAplStatus" :value="aplStatusInfo.code" v-on:change="confirmAplStatus"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{aplStatusInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="지역을 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="clubRegion_Name in clubRegion" :key="clubRegion_Name.name">
                      <label>
                        <input type="radio" v-model="selectClubRegion" :value="clubRegion_Name.code" v-on:change="setRegion"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{clubRegion_Name.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select04">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select04">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="사이즈를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="pin_Size in pinSizeArr" :key="pin_Size.size">
                      <label>
                        <input type="radio" v-model="selectPinSize" :value="pin_Size.code" v-on:change="setPinSize"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{pin_Size.size}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select05">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select05">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="사이즈를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="day_Week in dayWeekArr" :key="day_Week.day">
                      <label>
                        <input type="radio" v-model="selectDayWeek" :value="day_Week.cnt" v-on:change="setDayWeek"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{day_Week.day}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal closedHole">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body">
                    <div class="closedHole-header">
                      <div class="title">
                        휴장홀 선택
                      </div>
                      <div class="all">
                        <div class="caption">
                          전체선택
                        </div>
                        <div class="component-switch">
                          <div class="co-body">
                            <label>
                              <input type="checkbox" v-model="allSelectHolidayHoles" />
                              <i></i>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="closedHole-body">
                      <div class="bodyWrap">
                        <div class="table thead">
                          <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                          <div class="fixed" style="margin-left: -0px;">
                            <div class="contain">
                              <table>
                                <colgroup>
                                  <col class="course" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                  <col class="hole" />
                                </colgroup>
                                <thead>
                                <tr>
                                  <th class="course">
                                    <div class="item">
                                      코스
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      1
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      2
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      3
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      4
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      5
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      6
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      7
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      8
                                    </div>
                                  </th>
                                  <th class="hole">
                                    <div class="item">
                                      9
                                    </div>
                                  </th>
                                </tr>
                                </thead>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="table tbody">
                          <div class="contain">
                            <table>
                              <colgroup>
                                <col class="course" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                                <col class="hole" />
                              </colgroup>
                              <tbody>
                                <template v-for="(course, courseIndex) in selectHoleList" >
                                  <template v-for="(hole, holeIndex) in course.holes" >
                                    <tr :key="course.name + holeIndex">
                                      <td class="course" :rowspan="course.courseCycle"  v-if="holeIndex === 0" :style="{'border-bottom-left-radius': courseIndex === selectHoleList.length - 1 ? '7px' : ''}">
                                        {{ course.name }}
                                      </td>
                                      <td class="hole" v-for="(value, i) in hole" :key="i">
                                        <div class="checkbox">
                                          <label>
                                            <input type="checkbox" v-model="hole[i]" />
                                            <i></i>
                                          </label>
                                        </div>
                                      </td>
                                    </tr>
                                  </template>
                                </template>
                              </tbody>
                              <tbody class="none">
                              <tr>
                                <td colspan="20">
                                  데이터가 없습니다.
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeSelectHolidayHoles">
                      취소
                    </button>
                    <button class="confirm" @click="confirmSelectHolidayHoles">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import FooterLayout from '../layout/Footer.vue'
import HeaderLayout from '../layout/Header.vue'
import LeftLayout from '../layout/Left.vue'

import offMoment from 'moment'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { commonService, settingService, userService } from '../../router'

export default {
  name: 'SE004',
  data () {
    return {
      clubInfo: {
        club_name: '',
        club_logo: '',
        club_address: '',
        club_telno: '',
        club_represent_name: '',
        active_status: 'inactive',
        manage_status: 'inactive',
        apl_status: 'ready',
        pin_size: '',
        pin_change: '',
        uniqueness: '',
        holiday_start: '',
        holiday_end: '',
        holiday_week_ju: '',
        holiday_week: '',
        holiday_holes: '',
        region_code: ''
      },
      manageStatusName: '운영예정',
      selectManageStatus: 'inactive',
      manageStatusList: [
        {name: '운영중', code: 'active'},
        {name: '운영예정', code: 'inactive'}
      ],
      aplStatusName: '준비중',
      selectAplStatus: 'ready',
      aplStatusList: [
        {name: '서비스중', code: 'service'},
        {name: '점검중', code: 'check'},
        {name: '준비중', code: 'ready'}
      ],
      alertCallBack: null,
      pinSize: '',
      selectPinSize: '',
      pinSizeArr: [
        {size: '13', code: '0'},
        {size: '20', code: '1'},
        {size: '27', code: '2'}
      ],
      isOffDate: false,
      offDateRange: [new Date(), new Date(new Date().setDate(new Date().getDate() + 30))],
      sOffDate: '',
      eOffDate: '',
      dayWeek: '',
      selectDayWeek: '',
      selectHoles: '',
      dayWeekArr: [
        {day: '해제', cnt: -1},
        {day: '일요일', cnt: 0},
        {day: '월요일', cnt: 1},
        {day: '화요일', cnt: 2},
        {day: '수요일', cnt: 3},
        {day: '목요일', cnt: 4},
        {day: '금요일', cnt: 5},
        {day: '토요일', cnt: 6}
      ],
      clubRegionName: '',
      selectClubRegion: '',
      clubRegion: [
        {name: '경기/인천', code: 1},
        {name: '충청북도', code: 10},
        {name: '충청남도', code: 11},
        {name: '전라도', code: 20},
        {name: '경상북도', code: 30},
        {name: '경상남도', code: 31},
        {name: '강원도', code: 40},
        {name: '제주도', code: 50}
      ],
      checkDays: '',
      selectDay: [],
      checkDaysArr: [
        {name: '1주차', num: '1'},
        {name: '2주차', num: '2'},
        {name: '3주차', num: '3'},
        {name: '4주차', num: '4'},
        {name: '5주차', num: '5'}
      ],
      courseList: [],
      selectHoleList: []
    }
  },
  mounted: async function () {
    const { data } = await userService.getAll()
    this.userInfo = data

    if (this.userInfo.userRole === 'ClubManager') {
      this.currentClubCode = this.userInfo.ccode
    } else {
      this.currentClubCode = this.$route.query.ccode
    }
    await this.setData()
    commonService.getCourseListByCcode(this.currentClubCode).then(response => {
      this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
      this.setSelectCourseList()
    }).catch(error => {
      console.log('getCourseListByCcode.err.===>', error)
    })
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker
  },
  methods: {
    setData: function () {
      settingService.getClubInfoDetail(this.currentClubCode).then(response => {
        this.clubInfo = response.data.clubInfo
        this.selectManageStatus = this.clubInfo.manage_status
        this.selectAplStatus = this.clubInfo.apl_status
        this.selectPinSize = this.clubInfo.pin_size
        this.selectDayWeek = this.clubInfo.holiday_week
        this.selectHoles = this.clubInfo.holiday_holes
        this.selectDay = (this.clubInfo.holiday_week_ju) ? this.clubInfo.holiday_week_ju.split(',') : []
        this.setTime()
        this.confirmManageStatus()
        this.confirmAplStatus()
        this.selectClubRegion = this.setRegionCode(this.currentClubCode, this.clubInfo.region_code)
        this.setRegion()
        this.setPinSize()
        this.isOffDate = this.isHolidaysNotNull()
        this.setDayWeek()
      }).catch(error => {
        console.log('getClubInfoList.err.===>', error)
      })
    },
    saveData: function () {
      // 저장 시 서버쪽에서 한국시간 포매팅해서 DB저장
      if (this.clubInfo.club_name === '') {
        this.openAlert('골프클럽명을 입력해주세요', null)
        return false
      } else if (this.isOffDate && (!this.sOffDate || !this.eOffDate)) {
        this.openAlert('기간을 알맞게 선택해주세요', null)
        return false
      } else if (this.isOffDate && (this.checkDays.length === 0 && this.dayWeek)) {
        this.openAlert('주차를 설정해주세요', null)
        return false
      } else if (this.isOffDate && (this.checkDays.length !== 0 && !this.dayWeek)) {
        this.openAlert('요일을 설정해주세요', null)
        return false
      } else {
        if (this.isOffDate) {
          this.clubInfo.holiday_start = this.sOffDate
          this.clubInfo.holiday_end = this.eOffDate
          this.clubInfo.holiday_week_ju = this.checkDays.sort().join(',')
          this.clubInfo.holiday_week = this.selectDayWeek
          this.clubInfo.holiday_holes = this.computedSelectedHoles
        } else {
          this.clubInfo.holiday_start = ''
          this.clubInfo.holiday_end = ''
          this.clubInfo.holiday_week_ju = null
          this.clubInfo.holiday_week = -1
          this.clubInfo.holiday_holes = ''
        }
        settingService.updateClubInfo(this.currentClubCode, this.clubInfo).then(response => {
          if (response.statusCode === 200) {
            this.openAlert('저장되었습니다.', '/SE002?ccode=' + this.currentClubCode)
          } else {
            this.openAlert(response.message, null)
          }
        }).catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
      }
    },
    editCancel: function () {
      this.moveMenu('/SE002?ccode=' + this.currentClubCode)
    },
    confirmManageStatus: function () {
      this.clubInfo.manage_status = this.selectManageStatus
      this.manageStatusName = this.manageStatusList.find(it => it.code === this.clubInfo.manage_status).name
      this.closeSelectAll()
    },
    confirmAplStatus: function () {
      this.clubInfo.apl_status = this.selectAplStatus
      this.aplStatusName = this.aplStatusList.find(it => it.code === this.clubInfo.apl_status).name
      this.closeSelectAll()
    },
    handleImage: function (e) {
      const fileObj = e.target.files[0]
      this.createBase64Image(fileObj).then(data => {
        this.clubInfo.club_logo = data
      })
    },
    createBase64Image: function (fileObj) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(fileObj)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    updateValues: function (dateRange) {
      if (dateRange[0] && dateRange[1]) {
        this.sOffDate = offMoment(dateRange[0]).format('YYYY-MM-DD')
        this.eOffDate = offMoment(dateRange[1]).format('YYYY-MM-DD')
      } else {
        this.setTime()
      }
    },
    setRegion: function () {
      this.clubInfo.region_code = this.selectClubRegion
      if (!this.selectClubRegion) return
      this.clubRegionName = this.clubRegion.find(it => it.code === this.selectClubRegion).name
      this.closeSelectAll()
    },
    setPinSize: function () {
      this.clubInfo.pin_size = this.selectPinSize
      if (!this.selectPinSize) return
      this.pinSize = this.pinSizeArr.find(it => it.code === this.clubInfo.pin_size).size
      this.closeSelectAll()
    },
    setDayWeek: function () {
      this.checkDays = this.selectDay.filter(Boolean)
      if (this.selectDayWeek === -1 || (!this.selectDayWeek && this.selectDayWeek !== 0)) {
        this.dayWeek = null
      } else {
        this.dayWeek = this.dayWeekArr.find(it => it.cnt === this.selectDayWeek).day
      }
      this.closeSelectAll()
    },
    setTime: function () {
      if (this.clubInfo.holiday_start && this.clubInfo.holiday_end) {
        this.sOffDate = offMoment(this.clubInfo.holiday_start).format('YYYY-MM-DD')
        this.eOffDate = offMoment(this.clubInfo.holiday_end).format('YYYY-MM-DD')
        this.offDateRange = [
          offMoment(this.clubInfo.holiday_start).toDate(),
          offMoment(this.clubInfo.holiday_end).toDate()
        ]
      } else {
        this.sOffDate = offMoment(this.offDateRange[0]).format('YYYY-MM-DD')
        this.eOffDate = offMoment(this.offDateRange[1]).format('YYYY-MM-DD')
      }
    },
    isHolidaysNotNull: function () {
      if (this.clubInfo.holiday_start && this.clubInfo.holiday_end) {
        return true
      }
    },
    setSelectCourseList: function () {
      this.selectHoleList = []
      const holidayHoles = (this.selectHoles && this.selectHoles.split(',')) || []
      this.courseList.forEach((course, courseIndex) => {
        const courseCycle = Math.ceil((course.endIdx - course.startIdx) / 9)
        const courseInfo = {
          name: course.name,
          holes: [],
          courseCycle,
          startIdx: course.startIdx,
          endIdx: course.endIdx
        }
        for (let i = 0; i < courseCycle; i++) {
          const holes = []
          for (let j = 0; j < 9; j++) {
            holes.push(!!holidayHoles.find(hole => Number(hole) === (courseInfo.startIdx + (i * 9) + j + 1)))
          }
          courseInfo.holes.push(holes)
        }
        this.selectHoleList.push(courseInfo)
      })
    },
    selectHolidayHoles: function () {
      document.body.classList.add('modalClosedHoleActive')
    },
    confirmSelectHolidayHoles: function () {
      this.selectHoles = this.computedSelectedHoles
      this.closeSelectHolidayHoles()
    },
    closeSelectHolidayHoles: function () {
      this.setSelectCourseList()
      document.body.classList.remove('modalClosedHoleActive')
    },
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    }
  },
  computed: {
    computedSelectedHoles () {
      return this.selectHoleList.reduce((acc, curr, courseIndex) => {
        for (let i = 0; i < curr.courseCycle; i++) {
          acc = acc.concat(curr.holes[i].map((value, j) => {
            return value && (curr.startIdx + (i * 9) + j + 1)
          }).filter(v => v !== false))
        }
        return acc
      }, []).join(',')
    },
    holidayHoles () {
      if (!this.selectHoles) {
        return {}
      }
      return this.selectHoles.split(',').reduce((acc, curr) => {
        const course = this.getCourseData(curr - 1)
        if (!course) return
        const courseName = course.name
        if (acc[courseName]) {
          acc[courseName].push(curr - course.startIdx)
        } else {
          acc[courseName] = [curr - course.startIdx]
        }
        return acc
      }, {})
    },
    allSelectHolidayHoles: {
      get () {
        return this.selectHoleList.reduce((acc, curr) => {
          const l = !curr.holes.filter(hole => hole.find(value => !value) !== undefined).length
          return l && acc
        }, true)
      },
      set (value) {
        if (value) {
          const holeList = this.selectHoleList.map(v => v)
          holeList.forEach(course => {
            course.holes.forEach((hole, i) => {
              course.holes[i] = new Array(9).fill(true)
            })
          })
          this.selectHoleList = holeList
        } else {
          const holeList = this.selectHoleList.map(v => v)
          holeList.forEach(course => {
            course.holes.forEach((hole, i) => {
              course.holes[i] = new Array(9).fill(false)
            })
          })
          this.selectHoleList = holeList
        }
      }
    }
  }
}
</script>

<style scoped>
.modal.closedHole .body .closedHole-body .bodyWrap .table .contain table tr td.hole:first-child {
  border-left: 1px solid #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/SE004.vue